import * as popup_win_lose from "@assets/animation/popup-lose.svg";
import * as win_cup from "@assets/animation/popup-win-cup.svg";
import * as win_rays from "@assets/animation/win-rays.svg";
import * as win_stars from "@assets/animation/win-stars.svg";
import * as back_button_icon from "@assets/back-button-icon.svg";
import * as booster_offline_earnings_icon from "@assets/boosters/offline-earnings-icon.svg";
import * as booster_produce_speed_icon from "@assets/boosters/produce-speed-icon.svg";
import * as booster_produce_speed_image from "@assets/boosters/produce-speed-image.svg";
import * as booster_start_units_icon from "@assets/boosters/start-units-icon.svg";
import * as booster_start_units_image from "@assets/boosters/start-units-image.svg";
import * as cancel_icon from "@assets/cancel-icon.svg";
import * as confirm_icon from "@assets/confirm-icon.svg";
import * as coins_svg from "@assets/money-icon.svg";
import * as no_ads_icon from "@assets/no-ads-icon.svg";
import * as offline_earnings_image from "@assets/offline-earnings.svg";
import * as settings_icon from "@assets/settings-icon.svg";
import * as sound_icon from "@assets/sound-icon.svg";
import * as music_icon from "@assets/music-icon.svg";
import * as vibrate_icon from "@assets/vibrate-icon.svg";
import * as shop_icon from "@assets/shop-icon.svg";
import * as video_icon from "@assets/video_ad-icon.svg";
import * as leaderborard_play_icon from "@assets/leaderboard-play-icon.svg";
import * as leaderborard_cup_icon from "@assets/laederboard-cup-icon.svg";
import * as victory_framing from "@assets/victory-framing.svg";
import {ComponentClassName, Graphics} from "@dp-instant/ui";

type IconProps = ComponentClassName;

const ico = (svg: any, props: IconProps) => (
    <Graphics svg={svg} className={props.className} inline={false} />
);

export const Images = {
    Gift: () => <img src="./assets/gift-icon.svg" />,
    Star: () => <span className="star-emoji">⭐</span>,
    Ton: () => <img src="./assets/ton.png" className="ton-icon" />,
    Sbp: () => (
        <svg className="sbp-icon" width="24" height="24" viewBox="0 0 97 120" fill="none">
            <path d="M0 26.12l14.532 25.975v15.844L.017 93.863 0 26.12z" fill="#5B57A2"/>
            <path d="M55.797 42.643l13.617-8.346 27.868-.026-41.485 25.414V42.643z" fill="#D90751"/>
            <path d="M55.72 25.967l.077 34.39-14.566-8.95V0l14.49 25.967z" fill="#FAB718"/>
            <path d="M97.282 34.271l-27.869.026-13.693-8.33L41.231 0l56.05 34.271z" fill="#ED6F26"/>
            <path d="M55.797 94.007V77.322l-14.566-8.78.008 51.458 14.558-25.993z" fill="#63B22F"/>
            <path d="M69.38 85.737L14.531 52.095 0 26.12l97.223 59.583-27.844.034z" fill="#1487C9"/>
            <path d="M41.24 120l14.556-25.993 13.583-8.27 27.843-.034L41.24 120z" fill="#017F36"/>
            <path d="M.017 93.863l41.333-25.32-13.896-8.526-12.922 7.922L.017 93.863z" fill="#984995"/>
        </svg>
    )
};

export const SVG = {
    Shop: (props: IconProps) => ico(shop_icon, props),
    NO_ADS: (props: IconProps) => ico(no_ads_icon, props),
    COINS: (props: IconProps) => ico(coins_svg, props),
    BoosterOfflineEarningsIcon: (props: IconProps) => ico(booster_offline_earnings_icon, props),
    BoosterProduceSpeedIcon: (props: IconProps) => ico(booster_produce_speed_icon, props),
    BoosterProduceSpeed: (props: IconProps) => ico(booster_produce_speed_image, props),
    BoosterStartUnitsIcon: (props: IconProps) => ico(booster_start_units_icon, props),
    BoosterStartUnits: (props: IconProps) => ico(booster_start_units_image, props),
    BackButton: (props: IconProps) => ico(back_button_icon, props),
    PopupWinCup: (props: IconProps) => ico(win_cup, props),
    PopupLose: (props: IconProps) => ico(popup_win_lose, props),
    WinRays: (props: IconProps) => ico(win_rays, props),
    WinStars: (props: IconProps) => ico(win_stars, props),
    Video: (props: IconProps) => ico(video_icon, props),
    OfflineEarnings: (props: IconProps) => ico(offline_earnings_image, props),
    Settings: (props: IconProps) => ico(settings_icon, props),
    Sounds: (props: IconProps) => ico(sound_icon, props),
    Vibrate: (props: IconProps) => ico(vibrate_icon, props),
    Music: (props: IconProps) => ico(music_icon, props),
    Cancel: (props: IconProps) => ico(cancel_icon, props),
    Confirm: (props: IconProps) => ico(confirm_icon, props),
    LeaderBoardPlayIcon: (props: IconProps) => ico(leaderborard_play_icon, props),
    LeaderBoardCupIcon: (props: IconProps) => ico(leaderborard_cup_icon, props),
    VictoryFraming: (props: IconProps) => ico(victory_framing, props)
};

export {no_ads_icon, cancel_icon, confirm_icon, win_rays};
